var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMypageDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.3125V8.8125M8 15.3125L2.44 11.8375C1.98048 11.5503 1.75072 11.4067 1.62536 11.1805C1.5 10.9543 1.5 10.6834 1.5 10.1415V4.75M8 15.3125L11.25 13.2812L13.56 11.8375C14.0195 11.5503 14.2493 11.4067 14.3746 11.1805C14.5 10.9543 14.5 10.6834 14.5 10.1415V4.75M8 8.8125L1.5 4.75M8 8.8125L14.5 4.75M1.5 4.75L6.94 1.35C7.45547 1.02783 7.7132 0.866748 8 0.866748C8.2868 0.866748 8.54453 1.02783 9.06 1.35L14.5 4.75",
    stroke: "#33363F",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 10.0312C10.75 10.3074 10.9739 10.5312 11.25 10.5312C11.5261 10.5312 11.75 10.3074 11.75 10.0312H10.75ZM11.1246 6.85073L10.6873 7.09311L11.1246 6.85073ZM4.485 3.14275L10.045 6.61775L10.575 5.76975L5.015 2.29475L4.485 3.14275ZM11.75 10.0312V7.88975H10.75V10.0312H11.75ZM10.045 6.61775C10.2827 6.76634 10.4312 6.85976 10.5384 6.94195C10.6372 7.01766 10.6695 7.06092 10.6873 7.09311L11.562 6.60834C11.4545 6.41437 11.3092 6.27273 11.1468 6.1483C10.9929 6.03034 10.7968 5.90837 10.575 5.76975L10.045 6.61775ZM11.75 7.88975C11.75 7.62821 11.7505 7.39722 11.7321 7.20421C11.7126 7.0006 11.6695 6.80232 11.562 6.60834L10.6873 7.09311C10.7052 7.12531 10.7247 7.17559 10.7366 7.29947C10.7495 7.43395 10.75 7.60939 10.75 7.88975H11.75Z",
    fill: "#33363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMypageDelivery);
export default __webpack_public_path__ + "static/media/icon_mypage_delivery.96949f88a03234647b6ea6c4c9529540.svg";
export { ForwardRef as ReactComponent };